import { useEffect, useState } from "react";

import {
  applyTheme,
  readThemeChoice,
  resolveTheme,
  subscribeSystemTheme,
  systemTheme,
  THEME_STORAGE_KEY,
  writeThemeChoice,
  type ResolvedTheme,
  type ThemeChoice,
} from "./theme";

export function ThemeToggle() {
  const [choice, setChoice] = useState<ThemeChoice>(readThemeChoice);
  const [resolved, setResolved] = useState<ResolvedTheme>(() => resolveTheme(readThemeChoice()));

  useEffect(() => {
    setResolved(resolveTheme(choice));
    applyTheme(choice);
    if (choice !== "system") return;
    return subscribeSystemTheme(() => {
      applyTheme("system");
      setResolved(systemTheme());
    });
  }, [choice]);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key !== THEME_STORAGE_KEY) return;
      const next = readThemeChoice();
      setChoice(next);
      setResolved(resolveTheme(next));
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  function toggle() {
    const next: ThemeChoice = resolved === "dark" ? "light" : "dark";
    writeThemeChoice(next);
    setChoice(next);
  }

  const dark = resolved === "dark";

  return (
    <button
      type="button"
      className="theme-toggle"
      role="switch"
      aria-checked={dark}
      aria-label="Dark mode"
      onClick={toggle}
    >
      <span className="theme-toggle-knob" />
    </button>
  );
}
